import React from "react";
import styled from "styled-components";

const Anchor = styled.a`
    text-decoration: none !important;
    color: #6c6c6c !important;
`;

const BranchPhones = ({ branchPhones }) => (
    <div>
        {branchPhones &&
            branchPhones.map((branchPhone, index) => (
                <div key={index}>
                    {branchPhone.branchPhoneTypeName}:{" "}
                    <Anchor href={`tel:+1${branchPhone.normalizedPhoneNumber}`}>
                        {branchPhone.formattedPhoneNumber}
                    </Anchor>
                </div>
            ))}
    </div>
);

export default BranchPhones;



// WEBPACK FOOTER //
// ./components/details/BranchPhones.jsx